import { Component, OnInit } from '@angular/core';
import { QUICK_CREATE_CATEGORIES } from './quick-create.constants';
import { DialogService } from 'src/app/services/core/dialog.service';
import { CustomerCreateEditComponent } from 'src/app/modules/customer/customer-create-edit/customer-create-edit.component';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { CreateEditBidComponent } from 'src/app/modules/sale/bid/create-edit-bid/create-edit-bid.component';
import { CreateEditCustomerContactComponent } from 'src/app/modules/customer-contact/create-edit-customer-contact/create-edit-customer-contact.component';
import { CreateProposalComponent } from 'src/app/modules/sale/proposal/create-proposal/create-proposal.component';
import { NgDialogAnimationService } from 'src/app/services/core/ng-dialog-animation.service';
import { ToasterService } from 'src/app/services/core/toaster.service';
import { ProposalDataService } from 'src/app/modules/sale/proposal/proposal.data.service';
import { WarehouseCreateComponent } from 'src/app/modules/inventory/warehouse/warehouse-create/warehouse-create.component';
import { CreateChangeOrderComponent } from 'src/app/modules/sale/change-order/create-change-order/create-change-order.component';
import { CreateJobsiteComponent } from 'src/app/modules/jobsite/create-jobsite/create-jobsite.component';
import { AddPurchaseOrderSidebarComponent } from 'src/app/modules/purchase-order/add-purchase-order-sidebar/add-purchase-order-sidebar.component';
import { AddTaskComponent } from 'src/app/modules/sale/task/add-task/add-task.component';
import { AddTaskTemplateComponent } from 'src/app/modules/task/task-templates/add-task-template/add-task-template.component';
import { AddEditTicketComponent } from 'src/app/modules/ticket/add-edit-ticket/add-edit-ticket.component';
import { CreateNoteComponent } from 'src/app/modules/note/create-note/create-note.component';
import { StaffCreateEditComponent } from 'src/app/modules/hr/staff-create-edit/staff-create-edit.component';
import { CreateProposalScopeProductComponent } from 'src/app/modules/sale/proposal/form-part/quote/create-proposal-scope-product/create-proposal-scope-product.component';
import { CreateProposalScopeServiceComponent } from 'src/app/modules/sale/proposal/form-part/quote/create-proposal-scope-service/create-proposal-scope-service.component';
import { QuickSubcontractorComponent } from 'src/app/modules/sale/proposal/form-part/quote/create-proposal-scope-service/quick-subcontractor/quick-subcontractor.component';
import { QuickVendorComponent } from 'src/app/modules/sale/proposal/form-part/quote/create-proposal-scope-product/quick-vendor/quick-vendor.component';
@Component({
    selector: 'app-quick-create',
    templateUrl: './quick-create.component.html',
    styleUrls: ['./quick-create.component.scss'],
    standalone: false
})
export class QuickCreateComponent implements OnInit {
  quickCreateCategories = QUICK_CREATE_CATEGORIES;
  constructor(
    public dialogService: DialogService,
    private router: Router,
    public dialog: NgDialogAnimationService,
    private toasterService: ToasterService,
    public proposalDataService: ProposalDataService
  ) {}

  ngOnInit(): void {}

  openModal(itemLabel: string): void {
    switch (itemLabel) {
      case 'Customers':
        this.createCustomer();
        break;
      case 'Contacts':
        this.createContact();
        break;
      case 'Bids':
        this.createBid();
        break;
      case 'Proposals':
        this.createProposal();
        break;
      case 'Vendors':
        this.createVendor();
        break;
      case 'Warehouses':
        this.createWareHouse();
        break;
      case 'Products':
        this.createProduct();
        break;
      case 'Subcontractors':
        this.createSubcontractor();
        break;
      case 'Services':
        this.createService();
        break;
      case 'Change Orders':
        this.createChangeOrder();
        break;
      case 'Jobsites':
        this.createJobsite();
        break;
      case 'Purchase Orders':
        this.createPurchaseOrder();
        break;
      case 'Tasks':
        this.createTask();
        break;
      case 'Task Templates':
        this.createTaskTemplate();
        break;
      case 'Tickets':
        this.createTicket();
        break;
      case 'Notes':
        this.createNote();
        break;
      case 'Staff':
        this.createStaff();
        break;
      default:
        console.log(`No modal defined for ${itemLabel}`);
    }
  }

  createCustomer(): void {
    this.dialogService.onOpenFromRightDialog(CustomerCreateEditComponent);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if (result) {
        this.router.navigate([`customers/customer/${result?.id}`]);
        // this.callback.emit({reload:true});
      }
    });
  }

  createContact(): void {
    this.dialogService.onOpenFromRightDialog(
      CreateEditCustomerContactComponent
    );
    this.dialogService.afterClose()?.subscribe((result: any) => {
      // this.getData();
      //  this.callback.emit({reload:true});
    });
  }

  createBid(): void {
    this.dialogService.onOpenFromRightDialog(CreateEditBidComponent);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if (result) {
        this.router.navigate([`bids/bid/${result.data?.data?.id}`]);
      }
    });
  }

  createProposal(): void {
    const dialogRef = this.dialog.open(CreateProposalComponent, {
      width: '35%',
      maxHeight: '80vh',
      panelClass: 'proposal-dialog-container',
      autoFocus: false,
      data: {
        customer_id: '',
        customer_default_contact_id: '',
        proposalOrigin: 'proposalList',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const bid = result?.bid;
        let valid = true;

        if (bid.customers.length == 0) {
          this.toasterService.showWarning(
            'Please add bidder to the bid before creating a proposal'
          );
          valid = false;
        }
        // if(bid.contacts.length == 0){
        //   this.toasterService.showWarning('Please add contact to the bid before creating a proposal');
        //   valid = false;
        // }
        if (valid) {
          const modalSelectedOptions = {
            useBidScopes: true,
            useAllScopes: false,
          };
          const data = {
            // @ts-ignore
            subject: result?.bid?.name,
            tenant_id: result?.tenant_id,
            bid_id: bid?.id,
            customer_id: result?.customer_id,
            contact_id: result?.contact_id,
            // proposal_status: 2,
            include_scopes: modalSelectedOptions.useBidScopes
              ? 'bidScopesOnly'
              : 'allScopes',
          };
          this.proposalDataService
            .create(data)
            .pipe(first())
            .subscribe((data) => {
              this.router.navigate([
                'proposals/edit/' + data?.data?.proposal,
                {
                  bidId: result?.bid?.id,
                  proposalOrigin: result.proposalOrigin,
                  useBidScopes: modalSelectedOptions.useBidScopes,
                },
              ]);
            });
        }
      }
    });
  }

  createVendor(): void {
    const dialogRef = this.dialog.open(QuickVendorComponent, {
      width: '500px',
      maxHeight: '80vh',
      panelClass: 'quick-vendor-dialog-container',
    });
    dialogRef?.afterClosed()?.subscribe((result: any) => {
      if (result) {
        this.router.navigate([`vendors/vendor/${result?.data?.data?.id}`]);
      }
    });
  }

  createWareHouse(): void {
    this.dialogService.onOpenFromRightDialog(WarehouseCreateComponent);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if (result) {
        this.router.navigate([
          `warehouses/warehouse/${result?.data?.data?.id}`,
        ]);
      }
    });
  }

  createProduct = () => {
    const dialogRef = this.dialog.open(CreateProposalScopeProductComponent, {
      width: '800px',
      maxWidth: '800px',
      maxHeight: '80vh',
      panelClass: 'create-proposal-scope-product-dialog-container',
      autoFocus: false,
      data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result) {
          this.router.navigate([`products/product/${result?.id}`]);
        }
      }
    });
  };

  createSubcontractor(): void {
    const dialogRef = this.dialog.open(QuickSubcontractorComponent, {
      width: '500px',
      maxWidth: '500px',
      maxHeight: '80vh',
      panelClass: 'quick-subcontractor-dialog-container',
    });
    dialogRef?.afterClosed()?.subscribe((result: any) => {
      if (result) {
        this.router.navigate([`subcontractors/subcontractor/${result?.id}`]);
      }
    });
  }

  createService = () => {
    const dialogRef = this.dialog.open(CreateProposalScopeServiceComponent, {
      width: '900px',
      maxWidth: '900px',
      maxHeight: '80vh',
      panelClass: 'create-proposal-scope-service-dialog-container',
      autoFocus: false,
      data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.router.navigate(['services/service', result?.id]);
      }
    });
  };

  createChangeOrder(): void {
    this.dialogService.onOpenFromRightDialog(CreateChangeOrderComponent);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if (result) {
        this.router.navigate([`change-order/edit/${result?.id}`]);
      }
    });
  }
  createJobsite(): void {
    this.dialogService.onOpenFromRightDialog(CreateJobsiteComponent);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if (result) {
        this.router.navigate([`jobsites/jobsite/${result?.data?.data?.id}`]);
      }
    });
  }
  createPurchaseOrder() {
    this.dialogService.onOpenFromRightDialog(AddPurchaseOrderSidebarComponent);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if (result) {
        this.router.navigate([`bids/bid/${result.data?.data?.id}`]);
      }
    });
  }

  createTask(): void {
    this.dialogService.onOpenFromRightDialog(
      AddTaskComponent,
      {
        isTaskModule: true,
      },
      1300
    );
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if (result) {
        // this.pagination();
      }
    });
  }

  createTaskTemplate(): void {
    this.dialogService.onOpenFromRightDialog(
      AddTaskTemplateComponent,
      {
        isTaskModule: true,
      },
      1300
    );
    this.dialogService.afterClose()?.subscribe((result: any) => {
      // if(result) {
      // this.pagination();
      // }
    });
  }

  createTicket(): void {
    this.dialogService.onOpenFromRightDialog(
      AddEditTicketComponent,
      {
        isTicketModule: true,
      },
      1300
    );
    this.dialogService.afterClose()?.subscribe((result: any) => {
      // if(result) {
      // this.pagination();
      // }
    });
  }
  createNote(): void {
    this.dialogService.onOpenFromRightDialog(CreateNoteComponent, {}, 1300);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      // this.pagination();
    });
  }

  createStaff(): void {
    this.dialogService.onOpenFromRightDialog(StaffCreateEditComponent);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if (result) {
        this.router.navigate([`hr/staff/${result?.staff?.id}`]);
      }
    });
  }
}
